import { $t } from "helpers/translator";
import styles from './Reports.module.scss'
import { useState } from "react";
import NewReport from "components/Reports/Modals/NewReport/NewReport";
import ReportsTable from "components/Reports/ReportsTable";
import Modal from "components/miscellaneous/Modal/Modal";
import ScheduledReports from "../ScheduledReports";
import HasPermission from "../../../helpers/permissions/HasPermission";

function ReportsPage({ userType }) {
    const [ showModal, setShowModal ] = useState(false);

    const renderModal = () => {
        return (
            <Modal content={<NewReport userType={userType} visible={showModal} />}
                onClose={ (e) => {
                    setShowModal(false);
                } }
                visible={ showModal }
            />
        )
    }

    return (
        <>
            { renderModal() }
            <div className={ styles.container }>
                <div className={ 'box' }>
                    <div className={ 'alma-box' }>
                        <div className={ 'alma-box-header' }>
                            <div><h3>Clinic's Reports</h3></div>
                            <div>
                                <HasPermission permission="report.create">
                                    <button className="alma-button" onClick={(e) => {
                                        setShowModal(true);
                                    }}>Create a Report</button>
                                </HasPermission>
                            </div>
                        </div>
                        <div className={ `${'alma-box-content'}` }>
                            <ReportsTable />
                        </div>
                    </div>
                </div>
            </div>
            <div className={ styles.container }>
                <div className={ 'box' }>
                    <div className={ 'alma-box' }>
                        <div className={ 'ama-box-header' }>
                            <div>
                                <h3 style={{fontWeight: 400}}>Scheduled Report Sending Settings</h3>
                            </div>
                        </div>
                        <div className={ `${'alma-box-content'}` }>
                            <ScheduledReports userType={userType} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ReportsPage;
